module.exports = __webpack_public_path__ + "static/media/rm_06-28.f47e7e7f.png";